"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInAudienceNotAllowedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "SignInAudienceNotAllowed";
const messageKey = "driver.aadApp.error.signInAudienceNotAllowedAsPerAppPolicy";
class SignInAudienceNotAllowedError extends teamsfx_api_1.UserError {
    constructor(source, errorDetail, isMicrosoftUser = false) {
        const helpLink = isMicrosoftUser ? constants_1.constants.sniHelpLink : constants_1.constants.defaultHelpLink;
        super({
            source: source,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, errorDetail),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, errorDetail),
            helpLink: helpLink,
        });
    }
}
exports.SignInAudienceNotAllowedError = SignInAudienceNotAllowedError;
//# sourceMappingURL=signInAudienceNotAllowedError.js.map